import * as FileService from '../../services/attachment.service';

export const getDataFiles = async (filesMacros) => {
    const promises = filesMacros.map(async (fileMacro) => {
        const fileValues = fileMacro?.sourceentityvalue ?? null;
        if (!fileValues) return null;

        const fileIds = fileValues.split(",").map((id) => id.trim());
        if (fileIds.length === 0) return null;

        const fileResults = await Promise.all(
            fileIds.map(async (id) => {
                if (!id || id == "") return null;
                const fileData = await FileService.getFileDownloadBlob(id);
                if(fileData?.data.success) {
                    return fetchBytesAsFile(fileData.data);
                }
            })
        );
        return fileResults.filter(Boolean);
    });

    const results = await Promise.all(promises);
    return results.flat().filter(Boolean);
}

const fetchBytesAsFile = async (response) => {
    const base64 = response.data.data;
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: response.data.contenttype });
    return new File([blob], response.data.filename, { type: response.data.contenttype });
};